'use client';
import React, { createContext, useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { usePathname } from 'next/navigation';
import { useEnvVars } from '@web/app/contexts/EnvContext';
import { ElevarReporter } from './ElevarReporter';

export const ElevarReporterContext = createContext(null);

export const useElevarReporter = () => useContext(ElevarReporterContext);

export const useTrackElevarPage = page => {
  const elevarReporter = useElevarReporter();

  useEffect(() => {
    if (!elevarReporter?.userData || !page) return;
    elevarReporter.userData({ page_title: page });
  }, [elevarReporter, page]);
};

export const ElevarReporterProvider = ({ elevarReporter, children }) => {
  const pathname = usePathname();
  const envVars = useEnvVars();

  // Bridge the EnvContext into the ElevarReporter class.
  if (envVars?.OLLIE_ENV) {
    ElevarReporter.ollieEnv = envVars.OLLIE_ENV;
  }
  const prevPathname = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined' || !elevarReporter) return;
    window.ElevarInvalidateContext?.();

    // Fire on initial load OR on route change
    if (prevPathname.current === null || prevPathname.current !== pathname) {
      elevarReporter.userData({ page_title: pathname });
    }
    prevPathname.current = pathname;
  }, [pathname, elevarReporter]);

  return (
    <ElevarReporterContext.Provider value={elevarReporter}>
      {children}
    </ElevarReporterContext.Provider>
  );
};

ElevarReporterProvider.displayName = 'ElevarReporterProvider';
ElevarReporterProvider.propTypes = {
  elevarReporter: PropTypes.object.isRequired,
  children: PropTypes.node,
};
